module.exports = __webpack_public_path__ + "media/images/foal_reg-fefb427e12831a96f97ffbb3405c97f1.png";